import env from './env';

const portalThemes = {
  admin: {
    primaryColor: '#1677ff',
    successColor: '#52c41a',
    warningColor: '#faad14',
    errorColor: '#ff4d4f',
    infoColor: '#1677ff',
    borderRadius: 8,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    logo: '/assets/logos/admin/logo.png',
    favicon: '/favicons/admin.svg',
    themeColor: '#1677ff',
  },
  businessuser: {
    primaryColor: '#2f54eb',
    successColor: '#52c41a',
    warningColor: '#faad14',
    errorColor: '#ff4d4f',
    infoColor: '#2f54eb',
    borderRadius: 8,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    logo: '/assets/logos/businessuser/logo.svg',
    favicon: '/favicon.ico',
    themeColor: '#2f54eb',
  },
  merchant: {
    primaryColor: '#2b6cff',
    successColor: '#52c41a',
    warningColor: '#faad14',
    errorColor: '#ff4d4f',
    infoColor: '#2b6cff',
    borderRadius: 8,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    logo: '/assets/logos/merchant/logo.svg',
    favicon: '/favicons/merchant.svg',
    themeColor: '#2b6cff',
  },
};

export const getTheme = () => portalThemes[env.APP_TYPE] || portalThemes.admin;

export const getAntdTheme = () => {
  const theme = getTheme();
  return {
    token: {
      colorPrimary: theme.primaryColor,
      colorSuccess: theme.successColor,
      colorWarning: theme.warningColor,
      colorError: theme.errorColor,
      colorInfo: theme.infoColor,
      borderRadius: theme.borderRadius,
      fontFamily: theme.fontFamily,
    },
    components: {
      Layout: {
        siderBg: '#001529',
        triggerBg: '#002140',
      },
      Menu: {
        darkItemBg: '#001529',
        darkSubMenuItemBg: '#000c17',
      },
    },
  };
};

export default getTheme;
